import React from 'react';
import PropTypes from 'prop-types';

import { truncateString } from '../../../../../../util/text';
import Button from '../../../../../../components/global/Button';
import { getProDirectoryFormUrl } from '../../helpers';

const propTypes = {
  proDirectoryRecords: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      organization_name: PropTypes.string,
    }),
  ).isRequired,
};

const ProDirectoryResultListing = ({ proDirectoryRecords = [] }) => {
  return (
    <>
      {proDirectoryRecords.map(proDirectoryRecord => (
        <div
          className="pro-directory-item shadowed-search-result"
          key={proDirectoryRecord.id}
        >
          {proDirectoryRecord.logo_image?.url && (
            <img
              src={proDirectoryRecord.logo_image?.url}
              alt=""
              className="pro-directory-item-logo"
            />
          )}

          <div className="pro-directory-item-meta">
            <h4 className="mb-0">{proDirectoryRecord.organization_name}</h4>
            {proDirectoryRecord.pro_directory_description?.length > 0 && (
              <p>
                {truncateString(
                  proDirectoryRecord.pro_directory_description,
                  150,
                )}
              </p>
            )}
          </div>

          <Button
            className="pro-directory-item-cta"
            href={getProDirectoryFormUrl(proDirectoryRecord)}
            btnStyle="yellow"
            target="_parent"
          >
            Contact Photographer
          </Button>
        </div>
      ))}
    </>
  );
};

ProDirectoryResultListing.propTypes = propTypes;

export default ProDirectoryResultListing;
